import { render, staticRenderFns } from "./download-list.vue?vue&type=template&id=d5462312&"
import script from "./download-list.vue?vue&type=script&lang=js&"
export * from "./download-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports